import RequestDemo2 from './RequestDemo2';
import RequestDemo2Form from './RequestDemo2Form';

export { RequestDemo2Form };
export default RequestDemo2;
